/**
 * Shared CUSAGE/ETAS information banner.
 *
 * Used by:
 *  - App/Simulation/residential.js (residential simulator)
 *  - vteTools/Simulation/global_simulator.js (Pro / Market / Iframe / Extranet VTE)
 *
 * The banner is shown only when the selected category is 15 and the selected
 * work is 338, and its content depends on the selected CUSAGE value (1 or 2).
 */

var WARNING_ID = 'cusage-etas-warning';
var ICON_HTML = '<div class="cusage-etas-warning-icon"><img src="https://cdn.v2.primesenergie.fr/images/info.svg" alt="info" /></div>';

var MESSAGES = {
    2: ICON_HTML +
        '<div class="cusage-etas-warning-content">' +
            '<div class="cusage-etas-warning-main">Le système déporté dédié à la production d’eau chaude sanitaire doit être de la même marque que la pompe à chaleur.</div>' +
            '<div class="cusage-etas-warning-main">L’ETAS à prendre en compte est celui correspondant à une température d’eau de 55°C.</div>' +
            '<div class="cusage-etas-warning-sub"><strong>Où le trouver ?</strong> Sur la fiche technique du matériel ou après de votre professionnel</div>' +
        '</div>',
    1: ICON_HTML +
        '<div class="cusage-etas-warning-content">' +
            '<div class="cusage-etas-warning-main"><strong>L’ETAS</strong> dépend du type d’émetteurs de chaleur présents dans votre logement :</div>' +
            '<ul class="cusage-etas-warning-list">' +
                '<li>Plancher, murs, plafonds chauffants uniquement<br>' +
                    '<span class="cusage-etas-warning-arrow">→</span> L’ETAS à prendre en compte est celui correspondant à une température d’eau de 35°C</li>' +
                '<li>Radiateurs ou installation mixte (Radiateurs et plancher chauffants par exemple)<br>' +
                    '<span class="cusage-etas-warning-arrow">→</span> L’ETAS à prendre en compte est celui correspondant à une température d’eau de 55°C</li>' +
            '</ul>' +
            '<div class="cusage-etas-warning-sub"><strong>Où le trouver ?</strong> Sur la fiche technique du matériel ou après de votre professionnel</div>' +
        '</div>'
};

/**
 * Insert (or update) the CUSAGE/ETAS warning banner just after the given
 * container, and toggle its visibility based on the current selection.
 *
 * @param {object} opts
 * @param {jQuery} opts.cusageContainer       The wrapper element to insert the banner after.
 * @param {number} opts.selectedCategoryId    Currently selected category id.
 * @param {number} opts.selectedWorkId        Currently selected work id.
 * @param {number} opts.selectedCusageValue   Selected CUSAGE radio value (1 or 2).
 */
function renderCusageEtasWarning(opts) {
    var cusageContainer = opts.cusageContainer;
    if (!cusageContainer || !cusageContainer.length) {
        return;
    }

    var warningNode = $('#' + WARNING_ID);
    if (!warningNode.length) {
        warningNode = $('<div>', {
            id: WARNING_ID,
            class: 'cusage-etas-warning'
        });
    }

    warningNode.insertAfter(cusageContainer);

    var matchesCategoryWork = opts.selectedCategoryId === 15 && opts.selectedWorkId === 338;
    var messageHtml = MESSAGES[opts.selectedCusageValue];
    var shouldShowWarning = matchesCategoryWork && !!messageHtml;

    if (shouldShowWarning) {
        warningNode
            .removeClass('cusage-etas-warning--cusage-1 cusage-etas-warning--cusage-2')
            .addClass('cusage-etas-warning--cusage-' + opts.selectedCusageValue)
            .html(messageHtml)
            .addClass('is-visible');
    } else {
        warningNode.removeClass('is-visible');
    }
}

module.exports = {
    renderCusageEtasWarning: renderCusageEtasWarning,
    CUSAGE_ETAS_WARNING_MESSAGES: MESSAGES,
    CUSAGE_ETAS_WARNING_ID: WARNING_ID
};
